import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { Body2 } from '@estee/elc-typography';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { InfoIcon } from '@estee/elc-icons';
import { ProductNotifyMeInfoPopup } from './ProductNotifyMeInfoPopup';
import { Button } from '@estee/elc-buttons';

export interface IProductNotifyMeConfirmation {
    onNotifyMeNoticeInfoClick(): void;
    isGdprPopupOpen?: boolean;
    translations?: ITranslationsCollection;
}

const ProductNotifyMeInfoWrapper = styled.div`
    display: flex;
    justify-items: flex-end;
`;

const ProductNotifyMeInfoIcon = styled(InfoIcon)`
    width: 30px;
    height: 30px;
`;

const productNotifyMeInfoClassNames = classnames(
    'elc-product-notify-me-info',
    'js-product-notify-me-info'
);

const productNotifyMeInfoYourDataClassNames = classnames(
    'elc-product-notify-me-info-your-data',
    'js-product-notify-me-info-your-data'
);

const productNotifyMeInfoButtonClassNames = classnames(
    'elc-product-notify-me-info-button',
    'js-product-notify-me-info-button'
);

const productNotifyMeInfoIconClassNames = classnames(
    'elc-product-notify-me-info-icon',
    'js-product-notify-me-info-icon'
);

export const ProductNotifyMeInfo: React.FunctionComponent<IProductNotifyMeConfirmation> = translate(
    ['gdprHowDoWeUseYourData']
)(
    observer((props: IProductNotifyMeConfirmation) => {
        const { onNotifyMeNoticeInfoClick, isGdprPopupOpen, translations } = props;
        const { gdprHowDoWeUseYourData } = translations as ITranslationsCollection;

        return (
            <ProductNotifyMeInfoWrapper className={productNotifyMeInfoClassNames}>
                <Button
                    className={productNotifyMeInfoButtonClassNames}
                    onClick={onNotifyMeNoticeInfoClick}
                >
                    <ProductNotifyMeInfoIcon className={productNotifyMeInfoIconClassNames} />
                </Button>
                <Body2
                    className={productNotifyMeInfoYourDataClassNames}
                    onClick={onNotifyMeNoticeInfoClick}
                    dangerouslySetInnerHTML={{ __html: gdprHowDoWeUseYourData }}
                />
                <ProductNotifyMeInfoPopup isGdprPopupOpen={isGdprPopupOpen} />
            </ProductNotifyMeInfoWrapper>
        );
    })
);
